// Hook odpowiedzialny za pobranie najczęściej kupowanych produktów

import { axios } from 'api';
import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse,
  IProductListItem
} from 'api/types';

// parametry requestu do api
export type IRequest = IPaginationRequest & {
  scopes?: string;
  productIds?: string;
};

// typ zwracanych danych
type IResponse = IPaginationResponse<IProductListItem>;

const getCartMostBoughtProducts = (params?: IRequest): Promise<IResponse> =>
  axios.get('/carts/most-bought-products', { params });

export const useGetCartMostBoughtProducts = (
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['cart-most-bought-products', params],
    () => getCartMostBoughtProducts(params),
    options
  );

export const useGetCartMostBoughtProductsMutation = (
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => getCartMostBoughtProducts(data), options);
